import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";

import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ImageDialogComponent } from "../image-dialog/image-dialog.component";
import { ViewUserProfileQrCodeComponent } from "../view-user-profile-qr-code/view-user-profile-qr-code.component";

interface FollowUserCard {
  profilePicUrl: string | null;
  firstName: string | null;
  userName: string | null;
  customerEmail: string;
  isFollowing: boolean;
}

@Component({
  selector: "app-followers",
  templateUrl: "./followers.component.html",
  styleUrls: ["./followers.component.scss"],
})
export class FollowersComponent implements OnInit {
  profilePicture = "";
  showDefaultImage = false;
  uname = "";
  name = "";
  info = "";
  email = "";
  phone = "";
  website = "";

  ShowAboutYou = false;
  ShowEmail = false;
  ShowName = false;
  ShowWebsite = false;
  ShowPhone = false;

  FollowersCount = 0;
  FollowingCount = 0;

  followers: FollowUserCard[] = [];
  filteredFollowers: FollowUserCard[] = [];
  following: FollowUserCard[] = [];
  filteredFollowing: FollowUserCard[] = [];

  isInitialProfileDataLoading = true;
  isInitialFollowersLoading = true;
  isInitialFollowingLoading = true;

  isthereAnyFollowers = true;
  isthereAnyFollowing = true;

  isSearchOpen = false;
  searchInput = "";
  isSearchActive = false;

  activeTabIndex = 0;
  isMobileView = false;

  private userData: any;

  constructor(
    private flowServiceService: FlowServiceService,
    private router: Router,
    private userserviceService: UserserviceService,
    private dialog: MatDialog,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (!this.userData) {
      localStorage.setItem("returnUrl", "/followers");
      this.router.navigate(["/registration"]);
      return;
    }

    this.initialiseActiveTab();
    this.computeViewport();
    this.loadProfile();
    this.loadFollowers();
    this.loadFollowing();
  }

  @HostListener("window:resize")
  onResize(): void {
    this.computeViewport();
  }

  toggleSearch(): void {
    this.isSearchOpen = !this.isSearchOpen;
    if (!this.isSearchOpen) {
      this.searchInput = "";
      this.resetSearch();
    }
  }

  search(): void {
    const term = (this.searchInput || "").trim().toLowerCase();
    if (!term) {
      this.resetSearch();
      return;
    }

    this.isSearchActive = true;

    if (this.activeTabIndex === 0) {
      this.filteredFollowers = this.followers.filter((user) =>
        [user.firstName, user.userName, user.customerEmail]
          .filter(Boolean)
          .some((field) =>
            field!.toLowerCase().includes(term)
          )
      );
      this.isthereAnyFollowers = this.filteredFollowers.length > 0;
    } else {
      this.filteredFollowing = this.following.filter((user) =>
        [user.firstName, user.userName, user.customerEmail]
          .filter(Boolean)
          .some((field) =>
            field!.toLowerCase().includes(term)
          )
      );
      this.isthereAnyFollowing = this.filteredFollowing.length > 0;
    }
  }

  resetSearch(): void {
    this.isSearchActive = false;
    this.filteredFollowers = [...this.followers];
    this.filteredFollowing = [...this.following];
    this.isthereAnyFollowers = this.filteredFollowers.length > 0;
    this.isthereAnyFollowing = this.filteredFollowing.length > 0;
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.activeTabIndex = event.index;
    if (this.isSearchActive) {
      this.search();
    }
  }

  openImgDialog(): void {
    this.dialog.open(ImageDialogComponent);
  }

  gotoUserQrCode(): void {
    localStorage.removeItem("otherUserEmailAddress");
    localStorage.removeItem("otherUseruname");
    localStorage.setItem("otherUserEmailAddress", this.email);
    localStorage.setItem("otherUseruname", this.uname);
    this.dialog.open(ViewUserProfileQrCodeComponent, {
      panelClass: "dialoguebox",
    });
  }

  gotoProfile(): void {
    this.router.navigate(["/user-profile"]);
  }

  viewUserProfile(selectedUser: FollowUserCard): void {
    if (this.userData.emailAddress === selectedUser.customerEmail) {
      this.router.navigate(["/user-profile"]);
    } else {
      this.dataService.flowByCategorieschangeMessage(selectedUser);
      this.router.navigate(["/view-profile"]);
    }
  }

  follow(user: FollowUserCard): void {
    if (!this.userData) {
      localStorage.setItem("returnUrl", "/followers");
      this.router.navigate(["/registration"]);
      return;
    }

    const payload = {
      FollowerEmail: this.userData.emailAddress,
      UserEmail: user.customerEmail,
    };

    this.flowServiceService.FollowUser(payload).subscribe((data) => {
      const status = data?.isFollowing;
      user.isFollowing = status === "following";
      this.syncFollowState(user);
    });
  }

  private initialiseActiveTab(): void {
    const stored = localStorage.getItem("tabIndex");
    const parsed = stored !== null ? Number(stored) : 0;
    this.activeTabIndex = isNaN(parsed) ? 0 : parsed;
    localStorage.removeItem("tabIndex");
  }

  private computeViewport(): void {
    const width = window.innerWidth || document.body.clientWidth;
    this.isMobileView = width <= 1024;
  }

  private loadProfile(): void {
    this.userserviceService.getProfileUser().subscribe((data) => {
      const user = data?.userData;
      if (!user) {
        this.isInitialProfileDataLoading = false;
        return;
      }

      this.profilePicture = user.profilePicUrl || "";
      this.showDefaultImage = !this.profilePicture;
      this.email = user.emailAddress || "";
      this.phone = user.phoneNumber || "";
      this.info = user.info || "";
      this.website = user.website || "";
      this.uname = user.userName || "";
      this.name = user.firstName || "";

      this.ShowAboutYou = !!user.showAboutYou;
      this.ShowEmail = !!user.showEmail;
      this.ShowName = !!user.showName;
      this.ShowWebsite = !!user.showWebsite;
      this.ShowPhone = !!user.showPhone;

      this.FollowersCount = user.followerCount || 0;
      this.FollowingCount = user.followingCount || 0;

      this.isInitialProfileDataLoading = false;
    });
  }

  private loadFollowers(): void {
    this.isInitialFollowersLoading = true;
    const payload = { UserEmail: this.userData.emailAddress };

    this.flowServiceService.getFollowerUsers(payload).subscribe(
      (data: any[]) => {
        const list = (data || []).map((element) => ({
          profilePicUrl: element.profilePicUrl || null,
          firstName: element.firstName || null,
          userName: element.userName || null,
          customerEmail: element.emailAddress,
          isFollowing: !!element.isFollowing,
        }));

        this.followers = list;
        this.filteredFollowers = [...list];
        this.FollowersCount = list.length;
        this.isthereAnyFollowers = list.length > 0;
        this.isInitialFollowersLoading = false;
        this.applyCurrentFilter();
      },
      () => {
        this.followers = [];
        this.filteredFollowers = [];
        this.isthereAnyFollowers = false;
        this.isInitialFollowersLoading = false;
      }
    );
  }

  private loadFollowing(): void {
    this.isInitialFollowingLoading = true;
    const payload = { UserEmail: this.userData.emailAddress };

    this.flowServiceService.getFollowingUsers(payload).subscribe(
      (data: any[]) => {
        const list = (data || []).map((element) => ({
          profilePicUrl: element.profilePicUrl || null,
          firstName: element.firstName || null,
          userName: element.userName || null,
          customerEmail: element.emailAddress,
          isFollowing: true,
        }));

        this.following = list;
        this.filteredFollowing = [...list];
        this.FollowingCount = list.length;
        this.isthereAnyFollowing = list.length > 0;
        this.isInitialFollowingLoading = false;
        this.applyCurrentFilter();
      },
      () => {
        this.following = [];
        this.filteredFollowing = [];
        this.isthereAnyFollowing = false;
        this.isInitialFollowingLoading = false;
      }
    );
  }

  private syncFollowState(user: FollowUserCard): void {
    const syncState = (collection: FollowUserCard[]) => {
      const target = collection.find(
        (item) => item.customerEmail === user.customerEmail
      );
      if (target) {
        target.isFollowing = user.isFollowing;
      }
    };

    syncState(this.followers);
    syncState(this.following);

    if (!user.isFollowing) {
      this.following = this.following.filter(
        (item) => item.customerEmail !== user.customerEmail
      );
    } else {
      const exists = this.following.some(
        (item) => item.customerEmail === user.customerEmail
      );
      if (!exists) {
        this.following.push(user);
      }
    }

    this.FollowersCount = this.followers.length;
    this.FollowingCount = this.following.length;
    this.applyCurrentFilter();
  }

  private applyCurrentFilter(): void {
    if (this.isSearchActive && this.searchInput.trim()) {
      this.search();
      return;
    }

    this.filteredFollowers = [...this.followers];
    this.filteredFollowing = [...this.following];
    this.isthereAnyFollowers = this.filteredFollowers.length > 0;
    this.isthereAnyFollowing = this.filteredFollowing.length > 0;
  }
}
